import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

/**
 * Anything that changes money or an invite's status can change Payroll,
 * Payouts, Invites, payment history, proof review and analytics at once.
 * Call this after every such action so no screen shows a stale number.
 */
export const MONEY_QUERY_KEYS = [
  ['admin', 'invites'],
  ['admin', 'payroll'],
  ['admin', 'payouts'],
  ['admin', 'payment-events'],
  ['admin', 'analytics'],
  ['admin', 'screenshot-audit'],
  ['admin', 'inviters'],
  // Outreacher-portal keys predate the ['portal', …] convention.
  ['portal'],
  ['invites'],
  ['dashboard'],
] as const;

export function useInvalidateMoney(): () => void {
  const qc = useQueryClient();
  return useCallback(() => {
    for (const key of MONEY_QUERY_KEYS) void qc.invalidateQueries({ queryKey: [...key] });
  }, [qc]);
}
